import ReadonlyField from './ReadonlyField';

export default ReadonlyField;
